<template>
	<div>
		<div class="form-isheader-group">
			
			<div class="form-isheader-group-content">
				<el-upload disabled action="#" :file-list="files" list-type="picture-card" :auto-upload="false" :on-preview="viewpic" :on-remove="delpic">
					<i class="el-icon-plus"></i>
				</el-upload>
				<el-dialog :visible.sync="showpicbox">
					<img width="100%" :src="showpicurl" alt="">
				</el-dialog>
		
			</div>
		</div>

	</div>
</template>

<script>
	export default {
		props: ['order_id'],
		data() {
			return {
				showpicurl: '',
				showpicbox: false,
				
				files:[],
			};
		},
		methods: {
			delpic(file, fileList) {
				
			},
			viewpic(file) {
				this.showpicurl = file.url;
				this.showpicbox = true;
			},
			getdata() {
			
				this.post('/api/order/orderfiles', {
					order_id: this.order_id
				}).then((res) => {
					res.map((v)=>{
						let file ={
							name:'',
							url:this.apiurl+v.fileurl
						}
						this.files.push(file);
					})
					
				}).catch((err) => {
			
					console.log(err)
				})
			}
		},
		created() {
			this.getdata();
		}
	};
</script>

<style scoped>
	
</style>
